import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { SeoOptions, User } from '@box-types';
import { environment } from '@box-env/environment';
import { SEOService } from '@box-core/services';
import { getUserFullName, getInitials, deleteJsonLd } from '@box/utils';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalStateService } from '@box-core/services/global-state.service';

@Component({
  selector: 'account-details',
  templateUrl: './account-details.page.html',
  styleUrls: ['./account-details.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountDetailsPage implements OnInit, OnDestroy {
  public accountUrl: string;
  public userFullName: string;
  public userInitials: string;
  public mobilePhone: string;
  public email: string;
  public firstName: string;
  public lastName: string;
  public avatar: string;
  private user: User;

  constructor(
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router,
    private globalStateService: GlobalStateService
  ) {}

  ngOnInit(): void {
    this.user = this.globalStateService.getUser();
    this.accountUrl = environment.cosmote.ACCOUNT_URL + '/profile';
    this.userFullName = getUserFullName(this.user);
    this.userInitials = getInitials(this.userFullName).slice(0, 2);
    this.avatar = this.getCosmoteIDAvatar();
    this.mobilePhone = this.user.mobile?.phone ?? '';
    this.email = this.user.email ?? '';
    this.firstName = this.user.firstName;
    this.lastName = this.user.lastName;
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    deleteJsonLd();
  }

  public navigateToProfile(): void {
    window.location.href = this.accountUrl;
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }

  private getCosmoteIDAvatar(): string {
    const avatar = document.getElementById('csm_avatar');
    if (avatar) return avatar.getAttribute('src');
    return;
  }
}
